<template>
  <div >

     <nav-bar-jp v-if="isJP" :app="app" :dark="dark"/>

     <nav-bar-en v-else :app="app" :dark="dark"/>


  </div>

</template>


<style scoped>
.nav-background{
    /*background-color: #142e44;*/
    background-color: #519fd2;
    /*background-color: rgba(0, 0, 0, 0.5);*/
}


  #site-menu{
  background: none;
  /*   background-color: #2196F3;*/
  }

  /*.link-active{*/
  /*  background-color: #2196F3;*/
  /*}*/



  .link-box{
      padding: 5px 10px 5px 10px;
      background-color: white;
  }
  .link-box:hover{
      background-color: var(--color-highlight-primary);
  }

  .link{
      text-decoration: none;
      color: #3e3e3e;
      font-weight: 500;
      font-size: 14pt;
  }



</style>
<script>
import navBarEn from "@/components/navBarEn";
import navBarJp from "@/components/navBarJp";

export default {
  name: 'NavBar',

   props:{
     app: Boolean,
      dark: {type: Boolean, default: false}
   },
   components: {
      navBarEn, navBarJp
   },

   data: () => ({
     show_menu: false,

     items: [
        // {name: 'Home', url: '/'},
        // {name: 'Radio', url: '/radio'},
        {name: 'Links', url: '/links'},
        {name: 'Contact', url: '/contact'},
        {name: 'About Us', url: '/aboutus'},


     ]

  }),
   computed: {
      isJP() {
         return this.$store.state.lang === 'jp';
      },
   },

};
</script>
